import React, { useEffect, useState } from 'react'

import { Button, Card, Col, Form, Icon, Modal, Row, Switch, Table, Tooltip, Typography } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import { RULES, validRule } from '../../constants/Entitlements'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { getMessage } from '../../util/IntlMessages'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import sortText from '../../util/sortText'
import CustomInput from '../../components/CustomInput/customInput'
import './Category.css'
import { api, request } from '../../util/handlerRequestUtil'
import GroupIcon from '../../assets/images/group-icon.svg'
import AlertIcon from '../../assets/images/ico_erro.svg'

import { get } from 'lodash'
import { notification } from 'antd'

const ListCategoriesAndActions = ({ match, history }) => {
  const [filters, setFilters] = useState({})
  const [categories, setCategories] = useState([])
  const [currentCategoryName, setCurrentCategoryName] = useState('')
  const [formatedDataCategoryActions, setFormatedDataCategoryActions] = useState([])
  const { confirm } = Modal

  useEffect(() => {
    const hasAccess = validRule(RULES.CATEGORY)
    if (!hasAccess) {
      return history.push('/home')
    }

    fetchCategories()
  }, [])

  async function listCategoryActions(id) {
    try {
      const response = await request(api.getCategoryActionsByCategory(id))
      const formatedRows = []
      response.map((item) => {
        return formatedRows.push({
          key: get(item, 'id'),
          active: renderActiveAction(item.active),
          name: get(item, 'name'),
          classificacao: renderClassificationAction(item.classificacao),
          actions: renderCategoryAction(item.id, id)
        })
      })
      setFormatedDataCategoryActions(formatedRows)
      return formatedRows
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function fetchCategories(params) {
    const categories = await request(api.getCategoriesSearch(params))
    const formattedItems = categories.map((item) => ({
      ...item
    }))
    setCategories(formattedItems)
  }

  function setFilterFieldValue(field, value) {
    setFilters({
      ...filters,
      [field]: value
    })
  }

  function getCategoryActionColumns() {
    const columns = [
      {
        title: getMessage('categoryActionActive'),
        dataIndex: 'active',
        sorter: (a, b) => sortText(a, b, 'active'),
        width: '20%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('categoryActionName'),
        dataIndex: 'name',
        sorter: (a, b) => sortText(a, b, 'name'),
        width: '50%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },

      {
        title: getMessage('categoryActionClassificationBayer'),
        dataIndex: 'classificacao',
        sorter: (a, b) => sortText(a, b, 'classificacao'),
        width: '30%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      }
    ]
    columns.push({
      title: getMessage('label.actions'),
      dataIndex: 'actions',
      width: '10%'
    })
    return columns
  }

  const renderActiveAction = (id) => <Switch checked={id} />

  const renderClassificationAction = (id) => (
    <label>
      <Icon type="star" className="default-actionContent-icon" style={{ marginRight: 10 }} />
      {id}
    </label>
  )

  const renderCategoryAction = (idAction, idCategory) => (
    <div className="group-row-2">
      <Button
        className="default-actionContent-button"
        type="link"
        onClick={() => {
          history.push(`/categoryAction/${idAction}`)
        }}
      >
        <Icon type="edit" className="default-actionContent-icon" />
      </Button>

      <Button
        className="default-actionContent-button"
        type="link"
        onClick={() => {
          showConfirm(() => {
            deleteAction(idAction, idCategory)
          })
        }}
      >
        <Icon type="delete" className="default-actionContent-icon" />
      </Button>
    </div>
  )

  async function deleteAction(idAction, idCategory) {
    try {
      await api.deleteCategoryAction(idAction)
      listCategoryActions(idCategory)
    } catch (error_) {
      notification.error({
        description: getMessage('deleteActionError'),
        message: 'Erro'
      })
      console.tron.log(error_)
    }
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 10
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
        }
      },
      onCancel() {}
    })
  }

  function renderHeader() {
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <Button
            style={{ float: 'right' }}
            className="default-header-button button-action"
            type="primary"
            onClick={() => history.push('/category')}
          >
            {getMessage('createCategory')}
          </Button>
        </div>
      </div>
    )
  }

  function renderFilters() {
    const handleCleanFilters = () => {
      setFilters({})
      fetchCategories()
    }

    return (
      <div className="materials-filters">
        <Form layout="vertical">
          <div>
            <Row type="flex" justify="start">
              <CustomInput
                labelInput="Nome da Categoria ou Ação"
                label="nome"
                field="name"
                placeholder="Digite Aqui"
                setFieldValue={setFilterFieldValue}
                rowSpan={14}
                value={filters}
              />
            </Row>
          </div>
        </Form>
        <hr />
        <Row type="flex" justify="end">
          <Col span={5}>
            <Button icon="search" className="fetch-material-btn" type="dashed" onClick={() => fetchCategories(filters)}>
              {getMessage('search')}
            </Button>
          </Col>
          <Col span={5}>
            <Button className="cleanFiltersBtn" icon="close" type="ghost" onClick={handleCleanFilters}>
              {getMessage('cleanFilters')}
            </Button>
          </Col>
        </Row>
      </div>
    )
  }

  function renderCategoryTitle(category) {
    if (category.active) {
      return (
        <div>
          <Icon
            type={currentCategoryName === category.name ? 'up' : 'down'}
            style={{ marginRight: 13, fontSize: 15 }}
            onClick={() => {
              if (currentCategoryName === category.name) {
                setFormatedDataCategoryActions([])
                setCurrentCategoryName('')
              } else {
                setCurrentCategoryName(category.name)
                listCategoryActions(category.id)
              }
            }}
          />
          {category.name}{' '}
          <Tooltip title={category.proposito}>
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      )
    } else {
      return (
        <div style={{ color: '#999999' }}>
          <Icon
            type={currentCategoryName === category.name ? 'up' : 'down'}
            style={{ marginRight: 13, fontSize: 15 }}
            onClick={() => {
              if (currentCategoryName === category.name) {
                setFormatedDataCategoryActions([])
                setCurrentCategoryName('')
              } else {
                setCurrentCategoryName(category.name)
                listCategoryActions(category.id)
              }
            }}
          />
          <i>{category.name} </i>
          <Tooltip title={category.proposito}>
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      )
    }
  }

  function renderCategories() {
    return (
      <div style={{ padding: '2%' }}>
        <div className="default-header-div">
          <div className="default-header-breadcrumb">
            <Typography.Title className="default-header-title" level={3}>
              {getMessage('categories')}
            </Typography.Title>
          </div>
        </div>
        {categories.length === 0 ? (
          <div style={{ textAlign: '-webkit-center', margin: '10%' }}>
            <div>
              <img src={GroupIcon} alt="" />
              <Typography
                className="default-header-title"
                style={{ color: '#334863', padding: '10px 0px 10px' }}
                level={3}
              >
                {getMessage('emptyCategoryList')}
              </Typography>
            </div>
          </div>
        ) : (
          <>
            {categories.map((category) => (
              <>
                <div className="group-row">
                  <Typography level={2}>{renderCategoryTitle(category)}</Typography>
                  <div>
                    <Button
                      type="default"
                      style={{
                        borderColor: '#000',
                        color: '#000'
                      }}
                      disabled={!category.active}
                      onClick={() => {
                        history.push(`/categoryAction/`, { categoryId: category.id })
                      }}
                    >
                      <Icon type="left" style={{ marginRight: 13, fontSize: 15 }} />
                      {getMessage('createCategoryAction')}
                    </Button>
                    <Button
                      onClick={() => {
                        setCurrentCategoryName(category.name)
                        history.push(`/category/${category.id}`)
                      }}
                      style={{ borderRadius: 3, borderColor: '#d9d9d9', padding: 0, width: 36 }}
                    >
                      <Icon type="edit" style={{ color: '#818287', fontSize: 23, marginTop: 5, width: 22 }} />
                    </Button>
                  </div>
                </div>
                {formatedDataCategoryActions.length > 0 && currentCategoryName === category.name && (
                  <Table
                    columns={getCategoryActionColumns()}
                    dataSource={formatedDataCategoryActions}
                    pagination={false}
                  />
                )}
              </>
            ))}
          </>
        )}
      </div>
    )
  }

  return (
    <>
      {renderHeader()}
      <Card className="ant-card gx-card ant-card-bordered">
        {renderFilters()}
        {renderCategories()}
      </Card>
    </>
  )
}

export default ListCategoriesAndActions
